import { createFileRoute } from '@tanstack/react-router';
import { TransferHistory } from '@/components/transfer/transfer-history';

export const Route = createFileRoute('/history')({
  component: HistoryPage,
});

function HistoryPage() {
  return (
    <div className="container px-4 max-w-3xl mx-auto py-8">
      <TransferHistory />
    </div>
  );
}
